import React, { useEffect, useState } from 'react'
import HealthNav from '../Components/HealthNav'
import { HealthCheckModel } from '../../../Helper'
import HealthSidebar from '../Components/HealthSidebar'
import ModelsHealthStatus from '../Components/ModelsHealthStatus'
import { useGetHealthCheckStatusRequest } from '../../../store/Apis/HealthCheck'

const HealthCheck = () => {
  const {data: healthCheckStatusRequest , isLoading} = useGetHealthCheckStatusRequest();
  const [healthCheckFilter , setHealthCheckFilter] = useState<string | null>("");
  const [healthCheckData, setHealthCheckData] = useState<HealthCheckModel[]>([]);

  useEffect(() => {
    if(healthCheckStatusRequest){
      setHealthCheckData(healthCheckStatusRequest);
      setHealthCheckFilter(healthCheckStatusRequest[0].modelName)
    }
  },[healthCheckStatusRequest]);

  return (
   <div className='Heath-check'>
      <HealthNav/>
      <div className='Health-check-body'>
        <HealthSidebar setHealthCheckFilter={setHealthCheckFilter} filterModelName={healthCheckFilter} healthCheckData={healthCheckData}/>
        <ModelsHealthStatus filterModelName={healthCheckFilter} isLoading={isLoading} healthCheckData={healthCheckData}/>
      </div>
   </div>
  )
}

export default HealthCheck
